import BaseLayer from "./BaseLayer";
import {plotStitchGraphHelper, plotStitchGraphStartPositions} from "../utils/map_utils";

class StitchRound3Graphv2 extends BaseLayer {

    id = "stitchRound3Graphv2";
    label = "Path";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPathR3, stitchStartPosR3} = this.props;
        plotStitchGraphStartPositions(stitchStartPosR3, this.props.slide, this.layer.getSource());
        plotStitchGraphHelper(stitchPathR3, this.props.slide, this.layer.getSource());
        resolve();
    });
}

export default StitchRound3Graphv2;
